import {mapState} from "vuex";
import transport from "@/views/pages/project/sale/transport";
import {date} from "@/filters";

export default {
  data() {
    return {
      manifestCreate: {
        "manifest_stage_cd": 1,
        "manifest_type_cd": 1,
        "classification": 1,
        "date_of_issue": null,
        "number_of_issue": null,
        "control_number": null,
        "discharger_registration_number": null,
        "discharger_id":null,
        "discharger_name": null,
        "discharger_tel": null,
        "discharger_zip": null,
        "discharger_address_1": null,
        "discharger_address_2": null,
        "discharger_address_3": null,
        "discharger_address_4": null,
        "discharger_site_id": null,
        "discharger_site_name": null,
        "discharger_site_tel": null,
        "discharger_site_zip": null,
        "discharger_site_address_1": null,
        "discharger_site_address_2": null,
        "discharger_site_address_3": null,
        "discharger_site_address_4": null,
        "discharger_site_reporting_user_name": null,
        "discharger_site_handover_person_in_charge": null,
        "waste_id": null,
        "waste_category_major_classification_cd": null,
        "waste_category_medium_classification_cd": null,
        "waste_category_minor_classification_cd": null,
        "waste_category_subminor_classification_cd": null,
        "waste_category_cd": null,
        "waste_category_name": null,
        "amount_of_emissions": null,
        "quantity_confirmation_unit_cd": null,
        "quantity_confirmation_company_type_cd": null,
        "packing_type_cd": null,
        "packing_quantity": null,
        "transport_vendor_1_name": null,
        "transport_vendor_1_zip": null,
        "transport_vendor_1_address_1": null,
        "transport_vendor_1_address_2": null,
        "transport_vendor_1_address_3": null,
        "transport_vendor_1_address_4": null,
        "transport_vendor_1_contact_to": null,
        "transport_vendor_1_transport_method": null,
        "transport_vendor_1_transport_person_in_charge": null,
        "transport_vendor_1_car_number": null,
        "transport_and_hold_vendor_site_1_number": null,
        "transport_and_hold_vendor_site_1_name": null,
        "transport_and_hold_vendor_site_1_zip": null,
        "transport_and_hold_vendor_site_1_address_1": null,
        "transport_and_hold_vendor_site_1_address_2": null,
        "transport_and_hold_vendor_site_1_address_3": null,
        "transport_and_hold_vendor_site_1_address_4": null,
        "transport_and_hold_vendor_site_1_contact_to": null,
        "transport_vendor_2_name": null,
        "transport_vendor_2_zip": null,
        "transport_vendor_2_address_1": null,
        "transport_vendor_2_address_2": null,
        "transport_vendor_2_address_3": null,
        "transport_vendor_2_address_4": null,
        "transport_vendor_2_contact_to": null,
        "transport_vendor_2_transport_method": null,
        "transport_vendor_2_transport_person_in_charge": null,
        "transport_vendor_2_car_number": null,
        "transport_and_hold_vendor_site_2_number": null,
        "transport_and_hold_vendor_site_2_name": null,
        "transport_and_hold_vendor_site_2_zip": null,
        "transport_and_hold_vendor_site_2_address_1": null,
        "transport_and_hold_vendor_site_2_address_2": null,
        "transport_and_hold_vendor_site_2_address_3": null,
        "transport_and_hold_vendor_site_2_address_4": null,
        "transport_and_hold_vendor_site_2_contact_to": null,
        "transport_vendor_3_name": null,
        "transport_vendor_3_zip": null,
        "transport_vendor_3_address_1": null,
        "transport_vendor_3_address_2": null,
        "transport_vendor_3_address_3": null,
        "transport_vendor_3_address_4": null,
        "transport_vendor_3_contact_to": null,
        "transport_vendor_3_transport_method": null,
        "transport_vendor_3_transport_person_in_charge": null,
        "transport_vendor_3_car_number": null,
        "transport_and_hold_vendor_site_3_number": null,
        "transport_and_hold_vendor_site_3_name": null,
        "transport_and_hold_vendor_site_3_zip": null,
        "transport_and_hold_vendor_site_3_address_1": null,
        "transport_and_hold_vendor_site_3_address_2": null,
        "transport_and_hold_vendor_site_3_address_3": null,
        "transport_and_hold_vendor_site_3_address_4": null,
        "transport_and_hold_vendor_site_3_contact_to": null,
        "transport_vendor_4_name": null,
        "transport_vendor_4_zip": null,
        "transport_vendor_4_address_1": null,
        "transport_vendor_4_address_2": null,
        "transport_vendor_4_address_3": null,
        "transport_vendor_4_address_4": null,
        "transport_vendor_4_contact_to": null,
        "transport_vendor_4_transport_method": null,
        "transport_vendor_4_transport_person_in_charge": null,
        "transport_vendor_4_car_number": null,
        "transport_and_hold_vendor_site_4_number": null,
        "transport_and_hold_vendor_site_4_name": null,
        "transport_and_hold_vendor_site_4_zip": null,
        "transport_and_hold_vendor_site_4_address_1": null,
        "transport_and_hold_vendor_site_4_address_2": null,
        "transport_and_hold_vendor_site_4_address_3": null,
        "transport_and_hold_vendor_site_4_address_4": null,
        "transport_and_hold_vendor_site_4_contact_to": null,
        "transport_vendor_5_name": null,
        "transport_vendor_5_zip": null,
        "transport_vendor_5_address_1": null,
        "transport_vendor_5_address_2": null,
        "transport_vendor_5_address_3": null,
        "transport_vendor_5_address_4": null,
        "transport_vendor_5_contact_to": null,
        "transport_vendor_5_transport_method": null,
        "transport_vendor_5_transport_person_in_charge": null,
        "transport_vendor_5_car_number": null,
        "transport_and_hold_vendor_site_5_number": null,
        "transport_and_hold_vendor_site_5_name": null,
        "transport_and_hold_vendor_site_5_zip": null,
        "transport_and_hold_vendor_site_5_address_1": null,
        "transport_and_hold_vendor_site_5_address_2": null,
        "transport_and_hold_vendor_site_5_address_3": null,
        "transport_and_hold_vendor_site_5_address_4": null,
        "transport_and_hold_vendor_site_5_contact_to": null,
        "disposal_vendor_registration_number": null,
        "disposal_vendor_name": null,
        "disposal_vendor_zip": null,
        "disposal_vendor_address_1": null,
        "disposal_vendor_address_2": null,
        "disposal_vendor_address_3": null,
        "disposal_vendor_address_4": null,
        "disposal_vendor_tel": null,
        "disposal_vendor_site_registration_number": null,
        "disposal_vendor_site_name": null,
        "disposal_vendor_site_zip": null,
        "disposal_vendor_site_address_1": null,
        "disposal_vendor_site_address_2": null,
        "disposal_vendor_site_address_3": null,
        "disposal_vendor_site_address_4": null,
        "disposal_vendor_site_tel": null,
        "disposal_vendor_site_treatment_method": null,
        "is_reporting_wastes_on_intermediate_prosesses": null,
        "remarks_of_wastes_on_intermediate_prosesses": null,
        "is_reporting_wastes_on_final_disposal_site": null,
        "final_disposal_vendor_site_name": null,
        "final_disposal_vendor_zip": null,
        "final_disposal_vendor_address_1": null,
        "final_disposal_vendor_address_2": null,
        "final_disposal_vendor_address_3": null,
        "final_disposal_vendor_address_4": null,
        "final_disposal_vendor_tel": null,
        "remarks_1": null,
        "remarks_2": null,
        "remarks_3": null,
        "remarks_4": null,
        "remarks_5": null,
        "sub_transport_vendor_1_name": null,
        "sub_transport_vendor_1_registration_number": null,
        "sub_transport_vendor_1_end_date": null,
        "sub_transport_vendor_1_car_number": null,
        "sub_transport_vendor_1_transport_amount": null,
        "sub_transport_vendor_1_transport_unit": null,
        "sub_transport_vendor_1_valuables_amount": null,
        "sub_transport_vendor_1_valuables_unit": null,
        "sub_transport_vendor_1_reporting_user_name": null,
        "sub_transport_vendor_1_delivery_person_in_charge": null,
        "sub_transport_vendor_1_remarks": null,
        "sub_transport_vendor_2_name": null,
        "sub_transport_vendor_2_end_date": null,
        "sub_transport_vendor_2_car_number": null,
        "sub_transport_vendor_2_transport_amount": null,
        "sub_transport_vendor_2_transport_unit": null,
        "sub_transport_vendor_2_valuables_amount": null,
        "sub_transport_vendor_2_valuables_unit": null,
        "sub_transport_vendor_2_reporting_user_name": null,
        "sub_transport_vendor_2_delivery_person_in_charge": null,
        "sub_transport_vendor_2_remarks": null,
        "sub_transport_vendor_3_name": null,
        "sub_transport_vendor_3_end_date": null,
        "sub_transport_vendor_3_car_number": null,
        "sub_transport_vendor_3_transport_amount": null,
        "sub_transport_vendor_3_transport_unit": null,
        "sub_transport_vendor_3_valuables_amount": null,
        "sub_transport_vendor_3_valuables_unit": null,
        "sub_transport_vendor_3_reporting_user_name": null,
        "sub_transport_vendor_3_delivery_person_in_charge": null,
        "sub_transport_vendor_3_remarks": null,
        "sub_transport_vendor_4_name": null,
        "sub_transport_vendor_4_end_date": null,
        "sub_transport_vendor_4_car_number": null,
        "sub_transport_vendor_4_transport_amount": null,
        "sub_transport_vendor_4_transport_unit": null,
        "sub_transport_vendor_4_valuables_amount": null,
        "sub_transport_vendor_4_valuables_unit": null,
        "sub_transport_vendor_4_reporting_user_name": null,
        "sub_transport_vendor_4_delivery_person_in_charge": null,
        "sub_transport_vendor_4_remarks": null,
        "sub_transport_vendor_5_name": null,
        "sub_transport_vendor_5_end_date": null,
        "sub_transport_vendor_5_car_number": null,
        "sub_transport_vendor_5_transport_amount": null,
        "sub_transport_vendor_5_transport_unit": null,
        "sub_transport_vendor_5_valuables_amount": null,
        "sub_transport_vendor_5_valuables_unit": null,
        "sub_transport_vendor_5_reporting_user_name": null,
        "sub_transport_vendor_5_delivery_person_in_charge": null,
        "sub_transport_vendor_5_remarks": null,
        "sub_disposal_vendor_name": null,
        "sub_disposal_vendor_end_date": null,
        "sub_disposal_vendor_waste_reception_date": null,
        "sub_disposal_vendor_disposal_amount": null,
        "sub_disposal_vendor_disposal_unit": null,
        "sub_disposal_vendor_delivery_person_in_charge": null,
        "sub_disposal_vendor_delivery_car_number": null,
        "sub_disposal_vendor_reporting_user_name": null,
        "sub_disposal_vendor_treatment_person_in_charge": null,
        "sub_disposal_vendor_remarks": null,
        "sub_disposal_vendor_valuables": null,
        "sub_transport_and_hold_vendor_name": null,
        "sub_transport_and_hold_vendor_reporting_user_name": null,
        "sub_transport_and_hold_vendor_end_date": null,
        "transport_co2_emissions": null,
        "treatment_co2_emissions": null,
        "amount_of_co2_emissions": null,
        "vendor_transport_co2_emissions": null,
        "vendor_treatment_co2_emissions": null,
        "vendor_amount_of_co2_emissions": null,
        "customer_name": '',
        "waste_name": null,
        "is_special_waste": null,
        "daily_report_id": null,
        "wastes_or_services_by_daily_report_id": null,
      }
    };
  },
  methods: {
    getWasteId(wasteOrServiceId, listWasteOrServiceByWordOrder)
    {
      if (listWasteOrServiceByWordOrder) {
        let WasteOrServiceByWordOrder = listWasteOrServiceByWordOrder.find(x => x.id == wasteOrServiceId);
        if (WasteOrServiceByWordOrder && WasteOrServiceByWordOrder.waste) {
          return WasteOrServiceByWordOrder.waste.id;
        }
      }
      return null;
    },
    getWasteCategory(wasteOrServiceId, listWasteOrServiceByWordOrder) {
      if (listWasteOrServiceByWordOrder) {
        let WasteOrServiceByWordOrder = listWasteOrServiceByWordOrder.find(x => x.id == wasteOrServiceId);
        if (WasteOrServiceByWordOrder && WasteOrServiceByWordOrder.waste && WasteOrServiceByWordOrder.waste.waste_category) {
          return WasteOrServiceByWordOrder.waste.waste_category;
        }
      }
      return null;
    },
    getMajorClassificationCd(wasteCategory) {
      if (wasteCategory) {
        // JW廃棄物分類コード
        const fullId = wasteCategory.jw_waste_category_id;
        console.log(fullId);
        // 廃棄物大分類コード
        if (fullId.length < 7) {
          return null;
        }
        // 先頭2桁
        return fullId.substring(0, 2);
      }
      return null;
    },
    getMediumClassificationCd(wasteCategory) {
      if (wasteCategory) {
        // JW廃棄物分類コード
        const fullId = wasteCategory.jw_waste_category_id;
        // 廃棄物中分類コード
        if (fullId.length < 7) {
          return null;
        }
        // 3桁目
        return fullId.substring(2, 3);
      }
      return null;
    },
    getMinorClassificationCd(wasteCategory) {
      if (wasteCategory) {
        // JW廃棄物分類コード
        const fullId = wasteCategory.jw_waste_category_id;
        // 廃棄物小分類コード
        if (fullId.length < 7) {
          return null;
        }
        // 4桁目
        return fullId.substring(3, 4);
      }
      return null;
    },
    getSubminorClassificationCd(wasteCategory) {
      if (wasteCategory) {
        // JW廃棄物分類コード
        const fullId = wasteCategory.jw_waste_category_id;
        // 廃棄物細分類コード
        if (fullId.length < 7) {
          return null;
        }
        // 5～7桁目
        return fullId.substring(4, 7);
      }
      return null;
    },
    getWasteCategoryCd(wasteCategory) {
      if (wasteCategory) {
        // JW廃棄物分類コード
        return wasteCategory.jw_waste_category_id;
      }
      return null;
    },
    getWasteCategoryName(wasteCategory) {
      if (wasteCategory) {
        return wasteCategory.name_abbreviated;
      }
      return null;
    },
    getWasteName(wasteOrServiceId, listWasteOrServiceByWordOrder) {
      if (listWasteOrServiceByWordOrder) {
        let WasteOrServiceByWordOrder = listWasteOrServiceByWordOrder.find(x => x.id == wasteOrServiceId);
        if (WasteOrServiceByWordOrder && WasteOrServiceByWordOrder.waste)
          return WasteOrServiceByWordOrder.waste.name;
        return null;
      }
      return null;
    },
    getIsSpecialWaste(wasteOrServiceId, listWasteOrServiceByWordOrder) {
      if (listWasteOrServiceByWordOrder) {
        let WasteOrServiceByWordOrder = listWasteOrServiceByWordOrder.find(x => x.id == wasteOrServiceId);
        if (WasteOrServiceByWordOrder && WasteOrServiceByWordOrder.waste && WasteOrServiceByWordOrder.waste.waste_category) {
          let zzWasteCategoryTypeId = WasteOrServiceByWordOrder.waste.waste_category.zz_waste_category_type_id;
          if (zzWasteCategoryTypeId == 13)
            return 1;
          else
            return 0;
        }
      }
      return 0;
    },
    getQuantityConfirmationCompanyType(wasteOrServiceId, listWasteOrServiceByWordOrder) {
      if (listWasteOrServiceByWordOrder) {
        let WasteOrServiceByWordOrder = listWasteOrServiceByWordOrder.find(x => x.id == wasteOrServiceId);
        if (WasteOrServiceByWordOrder)
          return WasteOrServiceByWordOrder.zz_jw_quantity_confirmation_company_type_id;
        return null;
      }
      return null;
    },
    getPackingType(wasteOrServiceId, listWasteOrServiceByWordOrder) {
      if (listWasteOrServiceByWordOrder) {
        let WasteOrServiceByWordOrder = listWasteOrServiceByWordOrder.find(x => x.id == wasteOrServiceId);
        if (WasteOrServiceByWordOrder)
          return WasteOrServiceByWordOrder.waste?.zz_jw_packing_type_id;
        return null;
      }
      return null;
    },
    getTreatmentMethod(wasteOrServiceId, listWasteOrServiceByWordOrder) {
      if (listWasteOrServiceByWordOrder) {
        let WasteOrServiceByWordOrder = listWasteOrServiceByWordOrder.find(x => x.id == wasteOrServiceId);
        if (WasteOrServiceByWordOrder && WasteOrServiceByWordOrder.disposal_site && WasteOrServiceByWordOrder.disposal_site.disposal_site_by_waste_category)
          return WasteOrServiceByWordOrder.disposal_site.disposal_site_by_waste_category.zz_treatment_method.zz_jw_treatment_method_id;
      }
      return null;
    },
    getTreatmentMethodName(wasteOrServiceId, listWasteOrServiceByWordOrder) {
      if (listWasteOrServiceByWordOrder) {
        let WasteOrServiceByWordOrder = listWasteOrServiceByWordOrder.find(x => x.id == wasteOrServiceId);
        if (WasteOrServiceByWordOrder && WasteOrServiceByWordOrder.disposal_site && WasteOrServiceByWordOrder.disposal_site.disposal_site_by_waste_category)
          return WasteOrServiceByWordOrder.disposal_site.disposal_site_by_waste_category.zz_treatment_method.treatment_method;
      }
      return null;
    },
    getRemarks1(data, listWasteOrServiceByWordOrder) {
      let treatmentMethod = this.getTreatmentMethod(data.wastes_or_services_by_work_order_id, listWasteOrServiceByWordOrder)?.toString();
      let treatmentMethodName = this.getTreatmentMethodName(data.wastes_or_services_by_work_order_id, listWasteOrServiceByWordOrder)?.toString();

      if (treatmentMethod == '299') {
        let remarks = '処分方法：' + treatmentMethodName;
        // let wasteCategoryName = "";
        // let zzTreatmentMethod = ""
        // let wasteName = this.getWasteName(data.wastes_or_services_by_work_order_id, listWasteOrServiceByWordOrder) + "-";
        // if (listWasteOrServiceByWordOrder) {
        //   let WasteOrServiceByWordOrder = listWasteOrServiceByWordOrder.find(x => x.id == data.wastes_or_services_by_work_order_id);
        //   if (WasteOrServiceByWordOrder) {
        //     if (WasteOrServiceByWordOrder.waste && WasteOrServiceByWordOrder.waste.waste_category)
        //       wasteCategoryName = WasteOrServiceByWordOrder.waste.waste_category.name + "-";
        //     if (WasteOrServiceByWordOrder.disposal_site && WasteOrServiceByWordOrder.disposal_site.disposal_site_by_waste_category)
        //       zzTreatmentMethod = WasteOrServiceByWordOrder.disposal_site.disposal_site_by_waste_category.zz_treatment_method?.treatment_method;
        //   }
        // }
        // return remarks + wasteCategoryName + wasteName + zzTreatmentMethod;
        return remarks;
      }
      return null;
    },
    getScheduleCarNumber(wos) {
      if (wos.car_selected) {
        return wos.car_selected.area_name + wos.car_selected.classification_number + wos.car_selected.hiragana + wos.car_selected.number;
      }
      return null;
    },
    subStringData(value, length) {
      return value ? value.substring(0, length) : null;
    },
    mappingDataCreateManifest(data, manifestNumber,manifestTypeId, wasteName, co2Result = []) {

      if (data.daily_report.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.discharge) {
        //一次・二次（作業分類が排出のとき、manifest_stage_cdに2を設定）
        this.manifestCreate.manifest_stage_cd = 2;
      }
      if (data.daily_report.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.transshipment_storage) {
        //積替え保管の場合classificationを2に
        this.manifestCreate.classification = 2;
      }else{
        this.manifestCreate.classification = 1;
      }

      this.manifestCreate.manifest_type_cd = manifestTypeId;
      this.manifestCreate.daily_report_id = data.daily_report.id;
      this.manifestCreate.wastes_or_services_by_daily_report_id = data.id;
      //交付年月日
      this.manifestCreate.date_of_issue = data.date_of_issue ? data.date_of_issue : new Date().toISOString().substring(0, 10);
      //マニフェスト番号
      this.manifestCreate.number_of_issue = manifestNumber;
      //管理番号
      this.manifestCreate.control_number = data.remarks;
      //工場日報承認前のみ排出事業者情報を埋める
      // if(data.treatment_approved_status != 1) {
      //排出事業者treatment_approved_by_user
      this.manifestCreate.discharger_id = data.daily_report.work_order_json.case.discharger.id;
      this.manifestCreate.discharger_name = data.daily_report.work_order_json.case.discharger.name;
      this.manifestCreate.discharger_tel = data.daily_report.work_order_json.case.discharger.tel;
      this.manifestCreate.discharger_zip = data.daily_report.work_order_json.case.discharger.zip;
      this.manifestCreate.discharger_address_1 = this.subStringData(data.daily_report.work_order_json.case.discharger.address_1, 8);
      this.manifestCreate.discharger_address_2 = this.subStringData(data.daily_report.work_order_json.case.discharger.address_2, 40);
      this.manifestCreate.discharger_address_3 = data.daily_report.work_order_json.case.discharger.address_3;
      this.manifestCreate.discharger_address_4 = data.daily_report.work_order_json.case.discharger.address_4;
      //排出事業場
      this.manifestCreate.discharger_site_id = data.daily_report.work_order_json.case.discharger_site.id;
      this.manifestCreate.discharger_site_name = data.daily_report.work_order_json.case.discharger_site.name;
      this.manifestCreate.discharger_site_tel = data.daily_report.work_order_json.case.discharger_site.tel;
      this.manifestCreate.discharger_site_zip = data.daily_report.work_order_json.case.discharger_site.zip;
      this.manifestCreate.discharger_site_address_1 = this.subStringData(data.daily_report.work_order_json.case.discharger_site.address_1, 8);
      this.manifestCreate.discharger_site_address_2 = this.subStringData(data.daily_report.work_order_json.case.discharger_site.address_2, 40);
      this.manifestCreate.discharger_site_address_3 = data.daily_report.work_order_json.case.discharger_site.address_3;
      this.manifestCreate.discharger_site_address_4 = data.daily_report.work_order_json.case.discharger_site.address_4;
      // 登録担当者はマニフェスト作成時は空になるのが正しい（JWNへ登録を担当した人なので）
      //this.manifestCreate.discharger_site_reporting_user_name = this.subStringData(data.transport_approved_by_user ? data.transport_approved_by_user.user_name : (data.treatment_approved_by_user ? data.treatment_approved_by_user.user_name : null), 24);
      // 引渡担当者は排出の時にのみ設定する
      if (data.daily_report.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.discharge) {
        this.manifestCreate.discharger_site_handover_person_in_charge = data.daily_report.work_order_json.case.discharger_site?.user_handover_person?.user_name;
        if(!this.manifestCreate.discharger_site_handover_person_in_charge){
          this.manifestCreate.discharger_site_handover_person_in_charge = data?.factory_user?.user_name;
        }
      }else{
        this.manifestCreate.discharger_site_handover_person_in_charge = null;
      //}
    }

      // 廃棄物ID
      this.manifestCreate.waste_id = this.getWasteId(data.wastes_or_services_by_work_order_id, data.daily_report.work_order_json.waste_or_service_by_work_order);
      //廃棄物種類
      const wasteCategory = this.getWasteCategory(data.wastes_or_services_by_work_order_id, data.daily_report.work_order_json.waste_or_service_by_work_order);
      this.manifestCreate.waste_category_major_classification_cd = this.getMajorClassificationCd(wasteCategory);
      this.manifestCreate.waste_category_medium_classification_cd = this.getMediumClassificationCd(wasteCategory);
      this.manifestCreate.waste_category_minor_classification_cd = this.getMinorClassificationCd(wasteCategory);
      this.manifestCreate.waste_category_subminor_classification_cd = this.getSubminorClassificationCd(wasteCategory);
      this.manifestCreate.waste_category_cd = this.getWasteCategoryCd(wasteCategory);
      this.manifestCreate.waste_category_name = this.getWasteCategoryName(wasteCategory);
      //廃棄物
      this.manifestCreate.waste_name = this.getWasteName(data.wastes_or_services_by_work_order_id, data.daily_report.work_order_json.waste_or_service_by_work_order) ?? wasteName;
      this.manifestCreate.is_special_waste = this.getIsSpecialWaste(data.wastes_or_services_by_work_order_id, data.daily_report.work_order_json.waste_or_service_by_work_order);
      //排出量
      // this.manifestCreate.amount_of_emissions = data.measurement_quantity ? Math.round(data.measurement_quantity) : null;
      this.manifestCreate.amount_of_emissions = data.measurement_quantity ? data.measurement_quantity : null;
      this.manifestCreate.quantity_confirmation_unit_cd = data.zz_quantity_confirmation_unit_id;
      //数量確定者
      this.manifestCreate.quantity_confirmation_company_type_cd = this.getQuantityConfirmationCompanyType(data.wastes_or_services_by_work_order_id, data.daily_report.work_order_json.waste_or_service_by_work_order);
      //荷姿
      this.manifestCreate.packing_type_cd = this.getPackingType(data.wastes_or_services_by_work_order_id, data.daily_report.work_order_json.waste_or_service_by_work_order);
      //運搬事業者(区間) 1 to 5
      var lastIndex = 1;
      // リレーションからvendor_site取得
      let vendor_site = data.vendor_site;  
      if (data.daily_report.work_order_json.transport_contracts) {
        const transportContracts = data.daily_report.work_order_json.transport_contracts[0];
        
        for (let i = 1; i <= 5; i++) {
          if (transportContracts['vendor_id_section' + i]) {
            lastIndex = i;
            const vendorData = transportContracts['vendor_id_section' + i];
            const vendorPrefix = `transport_vendor_${i}`;

            this.manifestCreate[`${vendorPrefix}_name`] = vendorData.name;
            this.manifestCreate[`${vendorPrefix}_zip`] = vendorData.zip;
            this.manifestCreate[`${vendorPrefix}_address_1`] = this.subStringData(vendorData.address_1, 8);
            this.manifestCreate[`${vendorPrefix}_address_2`] = this.subStringData(vendorData.address_2, 40);
            this.manifestCreate[`${vendorPrefix}_address_3`] = vendorData.address_3;
            this.manifestCreate[`${vendorPrefix}_address_4`] = vendorData.address_4;
            this.manifestCreate[`${vendorPrefix}_contact_to`] = vendorData.tel;
          }
          if (transportContracts['zz_jw_transport_method' + i]) {
            const transportData = transportContracts['zz_jw_transport_method' + i];
            const transportPrefix = `transport_vendor_${i}`;

            this.manifestCreate[`${transportPrefix}_transport_method`] = transportData.id;
          }
          // 予定地が自社の場合、スケジュールで処分場の変更ができるためスケジュールの処分場（wosByDailyReport.vendor_site）
          // で差し替える必要がある点に注意
          const vendorSitePrefix = `transport_and_hold_vendor_site_${i}`;
          const vendorPrefix = `transport_and_hold_vendor_${i}`;
          if (transportContracts['vendor_site_id_section' + i]) {
            const vendorSiteData = transportContracts['vendor_site_id_section' + i];
            // 契約上の担当が自社かどうか
            if(vendorSiteData.zz_own_id == '1'){
              // 自社ならwosByDailyReport.vendor_siteを使う
              this.manifestCreate[`${vendorPrefix}_name`] = vendor_site.vendor.name;
              this.manifestCreate[`${vendorSitePrefix}_name`] = vendor_site.name;
              this.manifestCreate[`${vendorSitePrefix}_zip`] = vendor_site.zip;
              this.manifestCreate[`${vendorSitePrefix}_address_1`] = this.subStringData(vendor_site.address_1, 8);
              this.manifestCreate[`${vendorSitePrefix}_address_2`] = this.subStringData(vendor_site.address_2, 40);
              this.manifestCreate[`${vendorSitePrefix}_address_3`] = vendor_site.address_3;
              this.manifestCreate[`${vendorSitePrefix}_address_4`] = vendor_site.address_4;
              this.manifestCreate[`${vendorSitePrefix}_contact_to`] = vendor_site.tel;
              this.manifestCreate[`${vendorSitePrefix}_number`] = vendor_site.jwn_discharger_site_number;
              this.manifestCreate[`${vendorSitePrefix}_registration_number`] = vendor_site.discharger_registration_number;
            }else{
              // 契約を使う
              this.manifestCreate[`${vendorPrefix}_name`] = vendorSiteData.vendor.name;
              this.manifestCreate[`${vendorSitePrefix}_name`] = vendorSiteData.name;
              this.manifestCreate[`${vendorSitePrefix}_zip`] = vendorSiteData.zip;
              this.manifestCreate[`${vendorSitePrefix}_address_1`] = this.subStringData(vendorSiteData.address_1, 8);
              this.manifestCreate[`${vendorSitePrefix}_address_2`] = this.subStringData(vendorSiteData.address_2, 40);
              this.manifestCreate[`${vendorSitePrefix}_address_3`] = vendorSiteData.address_3;
              this.manifestCreate[`${vendorSitePrefix}_address_4`] = vendorSiteData.address_4;
              this.manifestCreate[`${vendorSitePrefix}_contact_to`] = vendorSiteData.tel;
              this.manifestCreate[`${vendorSitePrefix}_number`] = vendorSiteData.jwn_discharger_site_number;
              this.manifestCreate[`${vendorSitePrefix}_registration_number`] = vendorSiteData.discharger_registration_number;
            }
          }
        }

        //処分事業者
        // -- あくまでここは予定なので契約の処分場をいれたい
        // →予定地が自社の場合、スケジュールで処分場の変更ができるためスケジュールの処分場（wosByDailyReport.vendor_site）である必要がある。
        // また、積替え保管の場合自社が運搬担当の最後の運搬値が処分場とは限らないため、
        // 契約上の最終運搬先までしっかり見ること
        const disposalVendorSiteByPlan = transportContracts['vendor_site_id_section' + lastIndex];
        
        // 最終運搬先が自社か？
        if(disposalVendorSiteByPlan.zz_own_id == "1"){
          // 自社の場合はwosByDailyReport.vendor_siteを使う
          this.manifestCreate.disposal_vendor_name = vendor_site.vendor.name;
          this.manifestCreate.disposal_vendor_zip = vendor_site.vendor.zip;
          this.manifestCreate.disposal_vendor_address_1 = this.subStringData(vendor_site.vendor.address_1, 8);
          this.manifestCreate.disposal_vendor_address_2 = this.subStringData(vendor_site.vendor.address_2, 40);
          this.manifestCreate.disposal_vendor_address_3 = vendor_site.vendor.address_3;
          this.manifestCreate.disposal_vendor_address_4 = vendor_site.vendor.address_4;
          this.manifestCreate.disposal_vendor_tel = vendor_site.vendor.tel;
          //処分事業場
          this.manifestCreate.disposal_vendor_site_name = vendor_site.name;
          this.manifestCreate.disposal_vendor_site_zip = vendor_site.zip;
          this.manifestCreate.disposal_vendor_site_address_1 = this.subStringData(vendor_site.address_1, 8);
          this.manifestCreate.disposal_vendor_site_address_2 = this.subStringData(vendor_site.address_2, 40);
          this.manifestCreate.disposal_vendor_site_address_3 = vendor_site.address_3;
          this.manifestCreate.disposal_vendor_site_address_4 = vendor_site.address_4;
          this.manifestCreate.disposal_vendor_site_tel = vendor_site.tel;

          this.manifestCreate.disposal_vendor_registration_number = vendor_site.discharger_registration_number;
          // 事業場番号(加入者番号ではない)
          this.manifestCreate.disposal_vendor_site_registration_number = vendor_site.jwn_discharger_site_number;
        }else{
          // そうでない場合契約を使う
          this.manifestCreate.disposal_vendor_name = disposalVendorSiteByPlan.vendor.name;
          this.manifestCreate.disposal_vendor_zip = disposalVendorSiteByPlan.vendor.zip;
          this.manifestCreate.disposal_vendor_address_1 = this.subStringData(disposalVendorSiteByPlan.vendor.address_1, 8);
          this.manifestCreate.disposal_vendor_address_2 = this.subStringData(disposalVendorSiteByPlan.vendor.address_2, 40);
          this.manifestCreate.disposal_vendor_address_3 = disposalVendorSiteByPlan.vendor.address_3;
          this.manifestCreate.disposal_vendor_address_4 = disposalVendorSiteByPlan.vendor.address_4;
          this.manifestCreate.disposal_vendor_tel = disposalVendorSiteByPlan.vendor.tel;
          //処分事業場
          this.manifestCreate.disposal_vendor_site_name = disposalVendorSiteByPlan.name;
          this.manifestCreate.disposal_vendor_site_zip = disposalVendorSiteByPlan.zip;
          this.manifestCreate.disposal_vendor_site_address_1 = this.subStringData(disposalVendorSiteByPlan.address_1, 8);
          this.manifestCreate.disposal_vendor_site_address_2 = this.subStringData(disposalVendorSiteByPlan.address_2, 40);
          this.manifestCreate.disposal_vendor_site_address_3 = disposalVendorSiteByPlan.address_3;
          this.manifestCreate.disposal_vendor_site_address_4 = disposalVendorSiteByPlan.address_4;
          this.manifestCreate.disposal_vendor_site_tel = disposalVendorSiteByPlan.tel;

          this.manifestCreate.disposal_vendor_registration_number = disposalVendorSiteByPlan.discharger_registration_number;
          // 事業場番号(加入者番号ではない)
          this.manifestCreate.disposal_vendor_site_registration_number = disposalVendorSiteByPlan.jwn_discharger_site_number;
        }
      }

      //処分方法
      this.manifestCreate.disposal_vendor_site_treatment_method = this.getTreatmentMethod(data.wastes_or_services_by_work_order_id, data.daily_report.work_order_json.waste_or_service_by_work_order);
      //中間処理産業廃棄物
      this.manifestCreate.is_reporting_wastes_on_intermediate_prosesses = 3;
      //最終処分の場所
      this.manifestCreate.is_reporting_wastes_on_final_disposal_site = 0;
      //備考
      this.manifestCreate.remarks_1 = this.subStringData(this.getRemarks1(data, data.daily_report.work_order_json.waste_or_service_by_work_order), 50);
      //工場日報承認前のみ運搬事業者情報を埋める
      if(data.treatment_approved_status != 1 || this.manifestCreate.manifest_stage_cd == 2) {
      //運搬の受託(区間) 1 to 5
      if (data.daily_report.work_order_json.transport_contracts) {
        // 静和が担当した区間だけ入れる
        // また、積替え保管の場合を考慮し、該当する運搬区間の日報の場合のみ入力する
        const transportContracts = data.daily_report.work_order_json.transport_contracts[0];
        // 運搬区間
        let transport_and_hold_section = data.daily_report.schedule.transport_and_hold_section;
        for (let i = 1; i <= 5; i++) {
          // transport_and_hold_sectionは積替えの時以外は0なので注意！
          if(transport_and_hold_section == 0 ||
            transport_and_hold_section == i){
            const vendorPrefix = `sub_transport_vendor_${i}`;
            // 排出の場合(二次マニフェストの場合)運搬事業者の情報が必要になるため加入者番号だけ設定する
            if (transportContracts['vendor_id_section' + i] && 
               (transportContracts['vendor_id_section' + i]['zz_own_id'] == this.$constant.zzOwnId.is_own
                || this.manifestCreate.manifest_stage_cd == 2
               )
            ) {
              const vendorData = transportContracts['vendor_id_section' + i];
              if(vendorData.zz_own_id == this.$constant.zzOwnId.is_own){
                this.manifestCreate[`${vendorPrefix}_name`] = vendorData.name;
                this.manifestCreate[`${vendorPrefix}_end_date`] = data.transport_completed_date;
                this.manifestCreate[`${vendorPrefix}_car_number`] = this.getScheduleCarNumber(data);
                this.manifestCreate[`${vendorPrefix}_transport_amount`] = data.measurement_quantity ? data.measurement_quantity : null;
                this.manifestCreate[`${vendorPrefix}_transport_unit`] = data.zz_quantity_confirmation_unit_id;
                // 報告担当者はマニフェスト作成時には設定しない、連携時に設定する
                // this.manifestCreate[`${vendorPrefix}_reporting_user_name`] = this.subStringData(data.transport_approved_by ? data.transport_approved_by_user.user_name : null, 24);
                this.manifestCreate[`${vendorPrefix}_delivery_person_in_charge`] = this.subStringData(data.user ? data.user.user_name : null, 24);  
              }
              // 排出の場合(二次マニフェストの場合)運搬事業者の情報が必要になるため加入者番号だけ設定する
              const vendorSiteData = vendorData.vendor_site_for_trans;
              this.manifestCreate[`${vendorPrefix}_registration_number`] = (vendorSiteData && vendorSiteData.length && vendorSiteData.length > 0) ? vendorSiteData[0].discharger_registration_number : null;
            }
          }
        }
      }
      }
      // 処分の受託
      // 作業分類が収集運搬処分・処分の時のみ設定する
      // また、収集運搬処分では「工場」側が承認の時のみ設定する
      if(data.daily_report.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.disposal 
        || (data.daily_report.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.transportation_disposal 
          && data.treatment_approved_status == 1 )
      ){
        this.manifestCreate.sub_disposal_vendor_end_date = data.treatment_completed_date;
        this.manifestCreate.sub_disposal_vendor_name = data.vendor_site.vendor ? data.vendor_site.vendor.name : null;
        this.manifestCreate.sub_disposal_vendor_registration_number = data.vendor_site ? data.vendor_site.discharger_registration_number : null;
        this.manifestCreate.sub_disposal_vendor_waste_reception_date = data.transport_completed_date;
        this.manifestCreate.sub_disposal_vendor_disposal_amount = data.measurement_quantity ? data.measurement_quantity : null;
        this.manifestCreate.sub_disposal_vendor_disposal_unit = data.zz_quantity_confirmation_unit_id
        // this.manifestCreate.sub_disposal_vendor_delivery_person_in_charge = this.subStringData(data.user ? data.user.user_name : null, 24);
        // 処分の受託の車両番号は空でよい
        // this.manifestCreate.sub_disposal_vendor_delivery_car_number = this.getScheduleCarNumber(data);
        this.manifestCreate.sub_disposal_vendor_delivery_car_number = null;
        // 報告担当者はマニフェスト作成時には設定しない、報告時に設定する
        //this.manifestCreate.sub_disposal_vendor_reporting_user_name = this.subStringData(data.treatment_approved_by ? data.treatment_approved_by_user.user_name : null, 24);
        this.manifestCreate.sub_disposal_vendor_treament_person_in_charge = this.subStringData(data.treatment_approved_by ? data.treatment_approved_by_user.user_name : null, 24);
        this.manifestCreate.sub_disposal_vendor_valuables = data.zz_valuables_involved_type_id;
        this.manifestCreate.sub_disposal_vendor_treatment_person_in_charge = data?.factory_user?.user_name;
      }else{
        this.manifestCreate.sub_disposal_vendor_end_date = null;
        this.manifestCreate.sub_disposal_vendor_registration_number = null;
        this.manifestCreate.sub_disposal_vendor_name = null;
        this.manifestCreate.sub_disposal_vendor_waste_reception_date = null;
        this.manifestCreate.sub_disposal_vendor_disposal_amount = null;
        this.manifestCreate.sub_disposal_vendor_disposal_unit = null
        // this.manifestCreate.sub_disposal_vendor_delivery_person_in_charge = null;
        this.manifestCreate.sub_disposal_vendor_delivery_car_number = null;
        // this.manifestCreate.sub_disposal_vendor_reporting_user_name = null;
        this.manifestCreate.sub_disposal_vendor_treament_person_in_charge = null;
        this.manifestCreate.sub_disposal_vendor_valuables = null;
      }
      // 運搬の受託(積込) 基本的には積替え保管のときのみ以下は設定する
      if (data.daily_report.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.transshipment_storage) {
        this.manifestCreate.sub_transport_and_hold_vendor_name = data.vendor_site ? data.vendor_site.vendor?.name : null;
        this.manifestCreate.sub_transport_and_hold_vendor_reporting_user_name = this.subStringData(data.treatment_approved_by ? data.treatment_approved_by_user.user_name : null, 24);
        this.manifestCreate.sub_transport_and_hold_vendor_end_date = data.transport_and_hold_discharging_date;
      }
      //customer name
      this.manifestCreate.customer_name = data.daily_report.work_order_json.case.customer ? data.daily_report.work_order_json.case.customer.name : data.daily_report.work_order_json.case.customer_id;
      //mapping emissions co2 calculate to manifest params
      for (const key in co2Result) {
        this.manifestCreate[key] = co2Result[key];
      }
      // 加入者番号
      if (this.manifestCreate.manifest_stage_cd === 2) {
        // 排出事業者加入者番号は2次マニフェストの場合だけ設定
        this.manifestCreate.discharger_registration_number = data.daily_report.work_order_json.case.discharger_site.discharger_registration_number;
      }

    }
  },
}
